/* eslint-disable react-hooks/exhaustive-deps */
import {
  Box,
  Button,
  Container,
  TextField,
  Typography,
  Stack,
  ListItem,
  ListItemText,
  List,
} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { green } from "@mui/material/colors";
import SendIcon from "@mui/icons-material/Send";
import { useForm } from "react-hook-form";
import React, { useEffect, useState } from "react";
import api from "../../../../../services/api";
import Swal from "sweetalert2";
import { inputsName } from "../../../../../config/languageConst";
import { useLocation, useParams } from "react-router-dom";
import { LogTrackUser } from "../../../../../types/log-track-user/log-track-user";
import Cookies from "js-cookie";

export default function Countries() {
  const [circularLoading, setCircularLoading] = useState(false);
  const [requestError, setRequestError] = useState(false);
  const [requestErrorData, setRequestErrorData] = useState([]);
  const { id } = useParams<{ id: string }>();

  //User Tracking Logging Section //////////////////////////////////////
  let [alreadySetLog, setAlreadySetLog] = useState(false);
  const location = useLocation();
  if (!alreadySetLog) {
    LogTrackUser(Cookies.get("username"), location.pathname);
    setAlreadySetLog(true as boolean);
  }
  ///////////////////////////////////////////////////////////////////
  const {
    register,
    reset,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const onSubmit = (country: any) => {
    setCircularLoading(true);
    for (let index = 0; index < country.descriptions.length; index++) {
      country.descriptions[index].language_id = Number(
        country.descriptions[index].language_id
      );
      country.descriptions[index].updated_at = new Date().toISOString();
    }
    country.iso_code_2 = String(country.iso_code_2);
    country.iso_code_3 = String(country.iso_code_3);

    api
      .put(`countries/${id}`, country)
      .then((response) => {
        setCircularLoading(false);
        setRequestError(false);
        Swal.fire({
          title: "Shipping Company updated!",
          icon: "success",
          confirmButtonText: "Yes",
        });
        //reset();
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "" + error.response.data.message,
          footer: '<a href="">Why do I have this issue?</a>',
        });
        setCircularLoading(false);
        setRequestError(true);
        setRequestErrorData(error.response.data.message);
      });
  };

  const fetchCountry = async () => {
    const response = await api.get(`countries/${id}`);
    reset(response.data);
  };

  useEffect(() => {
    fetchCountry();
  }, []);

  return (
    <Container component="main" maxWidth="lg">
      <Box
        sx={{
          marginTop: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "start",
        }}
      >
        <Typography
          component="h1"
          variant="h5"
          sx={{ fontSize: "30px", marginBottom: "15px", color: "#556cd6" }}
        >
          Edit Country {id}
        </Typography>
        {requestError && (
          <List component="nav" aria-label="error">
            {requestErrorData.map((error) => (
              <ListItem key={error}>
                <ListItemText
                  sx={{
                    color: "red",
                  }}
                  primary={error}
                />
              </ListItem>
            ))}
          </List>
        )}
        <Box
          component="form"
          sx={{ mt: 1, minWidth: 3 / 4, width: "100%" }}
          onSubmit={handleSubmit(onSubmit)}
        >
          <Box sx={{ mt: 1, width: "100%" }}>
            <TextField
              sx={{ width: 1 / 4, marginRight: 8 }}
              InputLabelProps={{ shrink: true }}
              margin="normal"
              required
              fullWidth
              id="iso_code_2"
              type="text"
              label="Iso Code 2"
              {...register("iso_code_2", {})}
              autoFocus
            />

            <TextField
              sx={{ width: 1 / 4 }}
              InputLabelProps={{ shrink: true }}
              margin="normal"
              required
              fullWidth
              id="iso_code_3"
              type="text"
              label="Iso Code 3"
              {...register("iso_code_3", {
                required: "Name is required",
              })}
              autoFocus
            />
            <p style={{ color: "red", textAlign: "center" }}>
              {errors?.iso_code_2?.toString()}
            </p>
            <p style={{ color: "red", textAlign: "center" }}>
              {errors?.iso_code_3?.toString()}
            </p>
          </Box>
          <div style={{ marginTop: "30px" }}>
            {inputsName.map((input, index) => (
              <div
                className="flags-container"
                style={{ display: "block", marginTop: "50px" }}
                key={index}
              >
                <div className="fa-flags">
                  <img
                    src={`/assets/language/${input.language_id}.png`}
                    alt=""
                  />
                  &nbsp;-&nbsp;{input.language_name}
                </div>
                <input
                  hidden
                  {...register(`descriptions[${index}].language_id`, {
                    required: `descriptions[${index}].language_id is required`,
                  })}
                  value={input.language_id}
                />
                <TextField
                  sx={{ mt: 1, minWidth: 3 / 4 }}
                  InputLabelProps={{ shrink: true }}
                  margin="normal"
                  required
                  fullWidth
                  id={"#descriptions[" + index + "].name"}
                  type="text"
                  label="Name"
                  {...register(`descriptions[${index}].name`)}
                />
                <p style={{ color: "red", textAlign: "center" }}>
                  {errors?.descriptions?.toString()}
                </p>
              </div>
            ))}
          </div>

          <Stack
            direction="row"
            spacing={2}
            sx={{
              mt: 2,
            }}
          >
            <Button
              size="large"
              sx={{ marginTop: "10px", marginBottom: "10px" }}
              href="/countries"
            >
              Back
            </Button>
            <Button
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
              size="large"
              endIcon={<SendIcon />}
              disabled={circularLoading}
              type="submit"
            >
              Send
              {circularLoading && (
                <CircularProgress
                  size={24}
                  sx={{
                    color: green[500],
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    marginTop: "-12px",
                    marginLeft: "-12px",
                  }}
                />
              )}
            </Button>
          </Stack>
        </Box>
      </Box>
    </Container>
  );
}
